import { withKeys as _withKeys, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "col-sm-12" }
const _hoisted_2 = { class: "card card-body" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_5 = { class: "col p-0" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "form-group mb-2 col" }
const _hoisted_9 = { class: "col-auto p-0 text-end" }
const _hoisted_10 = { class: "overflow-auto" }
const _hoisted_11 = { class: "table table-striped border-light align-middle text-left text-nowrap position-relative" }
const _hoisted_12 = {
  key: 0,
  class: "text-capitalize-first"
}
const _hoisted_13 = { class: "text-capitalize-first" }
const _hoisted_14 = {
  key: 1,
  class: "text-capitalize-first"
}
const _hoisted_15 = { class: "text-end" }
const _hoisted_16 = ["title"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "text-end" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TraderOperatorForm = _resolveComponent("TraderOperatorForm")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _component_UserNameLabel = _resolveComponent("UserNameLabel")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_InviteLinkConfirmModal = _resolveComponent("InviteLinkConfirmModal")!
  const _component_ChangePasswordModal = _resolveComponent("ChangePasswordModal")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control form-control-sm",
                    onKeydown: _cache[0] || (_cache[0] = _withKeys(() => _ctx.applyFilters(), ["enter"])),
                    placeholder: _ctx.helper.trans('labels.name'),
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.requestDTO.query) = $event))
                  }, null, 40, _hoisted_7), [
                    [_vModelText, _ctx.requestDTO.query]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(() => _ctx.applyFilters(), ["prevent"])),
                  class: "btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first"
                }, _toDisplayString(_ctx.helper.trans('button.apply')), 1),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(() => _ctx.clearFilters(), ["prevent"])),
                  class: "btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first"
                }, _toDisplayString(_ctx.helper.trans('button.reset')), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("table", _hoisted_11, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _cache[10] || (_cache[10] = _createElementVNode("td", null, null, -1)),
                  (_ctx.isAdmin || _ctx.isOperator)
                    ? (_openBlock(), _createElementBlock("th", _hoisted_12, _toDisplayString(_ctx.helper.trans('labels.id')), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.helper.trans('labels.name')), 1),
                  (_ctx.isAdmin || _ctx.isOperator)
                    ? (_openBlock(), _createElementBlock("th", _hoisted_14, _toDisplayString(_ctx.helper.trans('labels.trader')), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("th", _hoisted_15, [
                    (_ctx.isAdmin || _ctx.isTrader)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showEditModal({}))),
                          class: "btn btn-outline-primary btn-sm text-capitalize"
                        }, _toDisplayString(_ctx.helper.trans('button.create')), 1))
                      : _createCommentVNode("", true),
                    _createVNode(_component_b_modal, {
                      "dialog-class": "modal-lg",
                      title: _ctx.createModalTitle,
                      modelValue: _ctx.createModal,
                      "body-class": "pt-0",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.createModal = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_TraderOperatorForm, { ref: "createForm" }, null, 512)
                      ]),
                      footer: _withCtx(() => [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.createModal = false)),
                          class: "btn btn-outline-secondary btn-sm text-capitalize-first"
                        }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1),
                        _createVNode(_component_LoaderWrapper, {
                          ref: "loaderCreateFrom",
                          zoom: 0.5
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("button", {
                              type: "button",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.save())),
                              class: "btn btn-outline-primary btn-sm text-capitalize-first"
                            }, _toDisplayString(_ctx.helper.trans('button.save')), 1)
                          ]),
                          _: 1
                        }, 512)
                      ]),
                      _: 1
                    }, 8, ["title", "modelValue"])
                  ])
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.response.items, (user) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: user.id,
                    class: ""
                  }, [
                    _createElementVNode("td", null, [
                      (user.isBlocked)
                        ? _withDirectives((_openBlock(), _createElementBlock("i", {
                            key: 0,
                            title: _ctx.helper.trans('labels.user_blocked'),
                            class: "fa fa-ban text-danger"
                          }, null, 8, _hoisted_16)), [
                            [
                              _directive_b_tooltip,
                              void 0,
                              void 0,
                              { hover: true }
                            ]
                          ])
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.isAdmin || _ctx.isOperator)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_17, _toDisplayString(user.id), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("td", null, [
                      _createVNode(_component_UserNameLabel, { user: user }, null, 8, ["user"])
                    ]),
                    (_ctx.isAdmin || _ctx.isOperator)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_18, [
                          (user.trader)
                            ? (_openBlock(), _createBlock(_component_UserNameLabel, {
                                key: 0,
                                user: user.trader
                              }, null, 8, ["user"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("td", _hoisted_19, [
                      (_ctx.isAdmin && _ctx.store.getters.hasPermission(_ctx.UserPermission.VIEW_USER_SESSION_HISTORY))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            onClick: _withModifiers(($event: any) => (_ctx.downloadSessionHistory(user.id)), ["prevent"]),
                            class: "btn btn-sm btn-outline-secondary text-nowrap text-capitalize me-2"
                          }, [
                            _cache[11] || (_cache[11] = _createElementVNode("i", { class: "fa fa-file-download" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.download_session_history')), 1)
                          ], 8, _hoisted_20))
                        : _createCommentVNode("", true),
                      (_ctx.isAdmin)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            onClick: ($event: any) => (_ctx.showEditModal(user)),
                            class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize"
                          }, [
                            _cache[12] || (_cache[12] = _createElementVNode("i", { class: "fa fa-pencil" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.edit')), 1)
                          ], 8, _hoisted_21))
                        : _createCommentVNode("", true),
                      (_ctx.isOperator && _ctx.store.getters.hasPermission(_ctx.UserPermission.RESET_TRADER_PASSWORD))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            type: "button",
                            onClick: _withModifiers(($event: any) => (_ctx.showChangePasswordModal(user)), ["prevent"]),
                            class: "btn btn-sm btn-outline-secondary text-nowrap text-capitalize"
                          }, [
                            _cache[13] || (_cache[13] = _createElementVNode("i", { class: "fa fa-key" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.change_password')), 1)
                          ], 8, _hoisted_22))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ])
            ]),
            (_ctx.response.totalCount > _ctx.response.items.length)
              ? (_openBlock(), _createBlock(_component_b_pagination, {
                  key: 0,
                  modelValue: _ctx.page,
                  "onUpdate:modelValue": [
                    _cache[8] || (_cache[8] = ($event: any) => ((_ctx.page) = $event)),
                    _cache[9] || (_cache[9] = ($event: any) => (_ctx.loadList()))
                  ],
                  "total-rows": _ctx.response.totalCount,
                  "per-page": _ctx.response.limit,
                  limit: 20,
                  "prev-text": "Back",
                  "next-text": "Next",
                  align: "start",
                  "first-number": "",
                  "hide-goto-end-buttons": "",
                  "hide-ellipsis": ""
                }, null, 8, ["modelValue", "total-rows", "per-page"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createVNode(_component_InviteLinkConfirmModal, { ref: "inviteLinkConfirmModal" }, null, 512),
      _createVNode(_component_ChangePasswordModal, { ref: "changePasswordModal" }, null, 512)
    ]),
    _: 1
  }, 512))
}